import React from 'react';
import ReactDropzone from 'react-dropzone';
import { observer } from 'mobx-react';

function BaasicDropzoneTemplate({ acceptFiles, onFilesDrop, placeholder }) {
	return (
		<ReactDropzone className="react-dropzone__box " accept={acceptFiles} onDrop={onFilesDrop}>
			<div className="react-dropzone__item">
				<div className="react-dropzone__add">
					<i className="react-dropzone__add__icon fa fa-plus-circle"></i>
					{placeholder != null && <p>{placeholder}</p>}
				</div>
			</div>
		</ReactDropzone>
	);
}

export default observer(BaasicDropzoneTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/BaasicDropzoneTemplate.jsx